import React, { Fragment } from 'react';

import useSafeSportCategoryMeasure from './UseSafeSportCategoryMeasure';

import SafeSportCategoryMeasureHeader from './components/SafeSportCategoryMeasureHeader';

import ElsewhereInSwimsView from '../../../components/views/elsewhereInSwimsView/ElsewhereInSwimsView';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

import Constants from '@usas/ui-web/utils/Constants';

const SafeSportElsewhereInSwims = () => {
  const {
    isLoading,
    programFocusState,
    onRedirectToCategory
  } = useSafeSportCategoryMeasure();

  if (!programFocusState || Object.keys(programFocusState?.levelCategoryObj).length === 0 ||
    Object.keys(programFocusState?.programLevelObj).length === 0) {
    return (
      <PageNotFound />
    );
  }

  return (
    <Fragment>
      <SafeSportCategoryMeasureHeader
        programCategory={programFocusState.levelCategoryObj}
        categoryMeasure={programFocusState.categoryMeasureObj}
        onBackClicked={onRedirectToCategory} />
      <div className="row">
        <div className="col-xs-12">
          <ElsewhereInSwimsView
            programLevel={programFocusState.programLevelObj}
            categoryMeasure={programFocusState.categoryMeasureObj}
            onRedirect={onRedirectToCategory} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default SafeSportElsewhereInSwims;